import { ICardResponse } from "./types";
import { cardsService } from "./cardsService";

export const getCards = async (): Promise<ICardResponse[]> => {
  const { data } = await cardsService.get("");

  return data;
};
